<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Visita</h3>
        <label>
          <div v-show="estado === 'N'" class="noti-info">
            <strong>NUEVA</strong>
          </div>
          <div v-show="estado === 'I'" class="noti-secondary">
            <strong>INICIADA</strong>
          </div>
          <div v-show="estado === 'A'" class="noti-danger">
            <strong>ANULADA</strong>
          </div>
          <div v-show="estado === 'P'" class="noti-primary">
            <strong>PENDIENTE</strong>
          </div>
          <div v-show="estado === 'F'" class="noti-success">
            <strong>FINALIZADA</strong>
          </div>
        </label>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button
            v-show="
              puede_consultar_visitas ||
              puede_editar_visita ||
              puede_eliminar_visita
            "
            class="btn-info btn--bigger"
            type="button"
            @click="consultar"
          >
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__title">
            <h5>Información de la visita</h5>
          </div>
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="datepicker-field">
                    <VueCtkDateTimePicker
                      id="fecha"
                      v-model="form.fecha"
                      locale="es"
                      no-label
                      :disabled="
                        (estado !== 'N' && estado !== 'P') ||
                        selectedRuta != null
                      "
                      button-now-translation="Ahora"
                      format="YYYY-MM-DD HH:mm"
                      formatted="YYYY-MM-DD HH:mm"
                      label="Seleccione fecha..."
                    />
                    <label>Fecha</label>
                    <span
                      v-if="errores.fecha"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.fecha[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-8">
                <div class="form-field">
                  <textarea-field
                    placeholder="Escriba una observación..."
                    id="observacion"
                    v-model="form.observacion"
                    :readonly="estado !== 'N' && estado !== 'P'"
                  >
                    <span>Observación</span>
                    <span
                      v-if="errores.observacion"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.observacion[0] }}</strong>
                    </span>
                  </textarea-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div
                  class="form-field select2"
                  :class="{
                    'select2--disabled': estado !== 'N' && estado !== 'P',
                  }"
                >
                  <div class="select2-field">
                    <v-select
                      @search="onSearchRutas"
                      @input="inputRuta"
                      id="ruta"
                      v-model="selectedRuta"
                      :options="rutas"
                      label="descripcion"
                      placeholder="Seleccione..."
                    ></v-select>
                    <label for="ruta">Ruta</label>
                    <span
                      v-if="errores.ruta_id"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.ruta_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div
                  class="form-field select2"
                  :class="{
                    'select2--disabled': estado !== 'N' && estado !== 'P',
                  }"
                >
                  <div class="select2-field">
                    <v-select
                      placeholder="Seleccione..."
                      :options="supervisores"
                      id="supervisor"
                      name="supervisor"
                      @input="inputSupervisor"
                      v-model="selectedSupervisor"
                      @search="searchSupervisores"
                      label="nombre"
                    ></v-select>
                    <label for="supervisor">Supervisor*</label>
                    <span
                      v-if="errores.supervisor_id"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.supervisor_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div
                  class="form-field select2"
                  :class="{
                    'select2--disabled': estado !== 'N' && estado !== 'P',
                  }"
                >
                  <div class="select2-field">
                    <v-select
                      placeholder="Seleccione..."
                      :options="verificadores"
                      id="verificador"
                      name="verificador"
                      @input="inputVerificador"
                      v-model="selectedVerificador"
                      @search="searchVerificadores"
                      label="descripcion"
                    ></v-select>
                    <label for="verificador">Verificador*</label>
                    <span
                      v-if="errores.verificador_id"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.supervisor_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div
                  class="form-field select2"
                  :class="{
                    'select2--disabled': estado !== 'N' && estado !== 'P',
                  }"
                >
                  <div class="select2-field">
                    <v-select
                      placeholder="Seleccione..."
                      :options="recaudadores"
                      id="recaudador"
                      name="recaudador"
                      @input="inputRecaudador"
                      v-model="selectedRecaudador"
                      @search="searchRecaudadores"
                      label="nombre"
                    ></v-select>
                    <label for="recaudador">Recaudador*</label>
                    <span
                      v-if="errores.recaudador_id"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.recaudador_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field select">
                  <div class="select-field">
                    <select
                      :disabled="estado !== 'N' && estado !== 'P'"
                      id="dia_cobro"
                      v-model="form.dia_cobro"
                    >
                      <option disabled value="">Seleccione...</option>
                      <option value="1">Lunes</option>
                      <option value="2">Martes</option>
                      <option value="3">Miércoles</option>
                      <option value="4">Jueves</option>
                      <option value="5">Viernes</option>
                      <option value="6">Sábado</option>
                      <option value="7">Domingo</option>
                    </select>
                    <label for="dia_cobro">Día de cobro</label>
                    <span
                      v-if="errores.dia_cobro"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.dia_cobro[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="col-xs-12 col-md-4"
                v-show="
                  form.descripcion_movimiento != '' &&
                  form.descripcion_movimiento != null
                "
              >
                <div class="form-field">
                  <input-field
                    id="descripcion_movimiento"
                    v-model="form.descripcion_movimiento"
                    readonly
                  >
                    <span>Movimiento</span>
                  </input-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card mt-2">
          <div class="card__title">
            <h5>Rubros iniciales</h5>
          </div>
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-3">
                <div class="form-field">
                  <input-field
                    id="almuerzo_inicial"
                    v-model="form.almuerzo_inicial"
                    vMoney
                    :readonly="
                      estado !== 'N' && estado !== 'P' && estado !== 'I'
                    "
                    :format="money"
                  >
                    <span>Almuerzo inicial</span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-3">
                <div class="form-field">
                  <input-field
                    id="peaje_inicial"
                    v-model="form.peaje_inicial"
                    :readonly="
                      estado !== 'N' && estado !== 'P' && estado !== 'I'
                    "
                    vMoney
                    :format="money"
                  >
                    <span>Peaje inicial</span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-3">
                <div class="form-field">
                  <input-field
                    id="combustible_inicial"
                    :readonly="
                      estado !== 'N' && estado !== 'P' && estado !== 'I'
                    "
                    v-model="form.combustible_inicial"
                    vMoney
                    :format="money"
                  >
                    <span>Combustible inicial</span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-3">
                <div class="form-field">
                  <input-field
                    id="otros_inicial"
                    v-model="form.otros_inicial"
                    :readonly="
                      estado !== 'N' && estado !== 'P' && estado !== 'I'
                    "
                    vMoney
                    :format="money"
                  >
                    <span>Otros valores iniciales</span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-3">
                <div class="form-field">
                  <input-field
                    id="total_rubros"
                    :value="totalRubros"
                    readonly
                    vMoney
                    :format="money"
                  >
                    <span>Total de rubros iniciales</span>
                  </input-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card mt-2">
          <div class="card__title">
            <h5>Vendedores</h5>
            <div class="card__controls">
              <div class="form-field select2">
                <div class="select2-field">
                  <v-select
                    @input="inputVendedor"
                    id="vendedor"
                    name="vendedor"
                    v-model="selectedVendedor"
                    :options="vendedores"
                    @search="searchVendedores"
                    label="descripcion"
                  ></v-select>
                  <label for="vendedor">Vendedor</label>
                </div>
              </div>
            </div>
          </div>
          <div class="card__content">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Dirección</th>
                    <th>Teléfonos</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(vendedor, index) in form.vendedores" :key="index">
                    <td>
                      {{ vendedor.descripcion }}
                    </td>
                    <td>
                      {{ vendedor.direccion }}
                    </td>
                    <td>
                      {{ vendedor.telefonos }}
                    </td>
                    <td>
                      <button
                        type="button"
                        @click="eliminarVendedor(index)"
                        class="btn-danger btn--text"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="form.vendedores.length == 0">
                    <td colspan="3">
                      <strong>Debe seleccionar una ruta con vendedores.</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-show="selectedRuta != null" class="card mt-2">
          <div class="card__title">
            <h5>Ítems</h5>
            <div class="card__controls">
              <div class="form-group">
                <div class="form-field">
                  <input-field
                    id="referencia_movimiento"
                    v-model="form.referencia_movimiento"
                    @keyup.enter="importar"
                    :readonly="form.items.length > 0"
                    placeholder="Indique un movimiento..."
                  ></input-field>
                </div>
                <button
                  v-show="form.items.length === 0"
                  class="btn-success btn--text"
                  type="button"
                  @click="importar"
                >
                  <i class="fa fa-download"></i>
                </button>
                <button
                  v-show="form.items.length > 0"
                  :disabled="estado !== 'N' && estado !== 'P'"
                  class="btn-danger btn--text"
                  type="button"
                  @click="quitarItems"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="card__content">
            <items-visitas
              :editable="estado == 'N' || estado == 'P'"
              v-model="form.items"
            ></items-visitas>
          </div>
        </div>
        <div v-show="estado !== 'N'" class="card mt-2">
          <div class="card__content">
            <items-adicionales
              :ruta_id="form.ruta_id"
              :editable="estado == 'N' || estado == 'P' || estado === 'I'"
              v-model="form.movimientosAdicionales"
              :visitaId="id"
            ></items-adicionales>
          </div>
        </div>
        <div class="card mt-2">
          <div class="card__title">
            <h5>Información adicional</h5>
          </div>
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field
                    id="fecha_inicio"
                    v-model="form.fecha_inicio"
                    placeholder="YYYY-MM-DD HH:mm:ss"
                    readonly
                  >
                    <span>Fecha de inicio</span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="form-group">
                    <textarea-field
                      placeholder="Observación..."
                      id="observacion_inicio"
                      v-model="form.observacion_inicio"
                      readonly
                    >
                      <span>Observación de inicio</span>
                      <span
                        v-if="errores.observacion_inicio"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.observacion_inicio[0] }}</strong>
                      </span>
                    </textarea-field>
                    <button
                      v-show="
                        form.latitud_inicio != '' && form.longitud_inicio != ''
                      "
                      type="button"
                      @click="verCoordenadasInicio"
                      class="btn-info btn--text"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <textarea-field
                    placeholder="Dirección..."
                    id="direccion_inicio"
                    v-model="form.direccion_inicio"
                    readonly
                  >
                    <span>Dirección de inicio</span>
                    <span
                      v-if="errores.direccion_inicio"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.direccion_inicio[0] }}</strong>
                    </span>
                  </textarea-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field
                    id="fecha_fin"
                    v-model="form.fecha_fin"
                    placeholder="YYYY-MM-DD HH:mm:ss"
                    readonly
                  >
                    <span>Fecha de fin</span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="form-group">
                    <textarea-field
                      placeholder="Escriba una observación..."
                      id="observacion_fin"
                      v-model="form.observacion_fin"
                      readonly
                    >
                      <span>Observación de fin</span>
                      <span
                        v-if="errores.observacion_fin"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.observacion_fin[0] }}</strong>
                      </span>
                    </textarea-field>
                    <button
                      v-show="form.latitud_fin != '' && form.longitud_fin != ''"
                      type="button"
                      @click="verCoordenadasFin"
                      class="btn-info btn--text"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <textarea-field
                    placeholder="Dirección..."
                    id="direccion_fin"
                    v-model="form.direccion_fin"
                    readonly
                  >
                    <span>Dirección de fin</span>
                    <span
                      v-if="errores.direccion_fin"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.direccion_fin[0] }}</strong>
                    </span>
                  </textarea-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field
                    id="fecha_cancelacion"
                    v-model="form.fecha_cancelacion"
                    placeholder="YYYY-MM-DD HH:mm:ss"
                    readonly
                  >
                    <span>Fecha de cancelación</span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="form-group">
                    <textarea-field
                      placeholder="Escriba una observación..."
                      id="observacion_cancelacion"
                      v-model="form.observacion_cancelacion"
                      readonly
                    >
                      <span>Observación de cancelación</span>
                      <span
                        v-if="errores.observacion_cancelacion"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{
                          errores.observacion_cancelacion[0]
                        }}</strong>
                      </span>
                    </textarea-field>
                    <button
                      v-show="
                        form.latitud_cancelacion != '' &&
                        form.longitud_cancelacion != ''
                      "
                      type="button"
                      @click="verCoordenadasCancelacion"
                      class="btn-info btn--text"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <textarea-field
                    placeholder="Dirección..."
                    id="direccion_fin"
                    v-model="form.direccion_cancelacion"
                    readonly
                  >
                    <span>Dirección de cancelación</span>
                    <span
                      v-if="errores.direccion_cancelacion"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.direccion_cancelacion[0] }}</strong>
                    </span>
                  </textarea-field>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div style="height: 350px">
                  <l-map
                    @update:zoom="zoomUpdated"
                    @update:center="centerUpdated"
                    style="height: 100%; width: 100%"
                    :zoom="zoom"
                    :center="center"
                  >
                    <l-tile-layer :url="url"></l-tile-layer>
                    <l-marker
                      v-if="latLngInicio != null"
                      :icon="markerIcon"
                      :lat-lng="latLngInicio"
                    ></l-marker>
                    <l-marker
                      v-if="latLngFin != null"
                      :icon="markerIcon"
                      :lat-lng="latLngFin"
                    ></l-marker>
                    <l-marker
                      v-if="latLngCancelacion != null"
                      :icon="markerIcon"
                      :lat-lng="latLngCancelacion"
                    ></l-marker>
                  </l-map>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button
              v-show="
                (estado === 'N' && puede_crear_visita) ||
                ((estado === 'P' || estado === 'I') && puede_editar_visita)
              "
              type="button"
              @click="guardar"
              class="btn-success"
            >
              <i class="fa fa-save"></i><span>Guardar</span>
            </button>
            <button
              v-show="estado !== 'N'"
              type="button"
              @click="nueva"
              class="btn-primary btn--text"
            >
              <i class="fa fa-plus"></i><span>Nueva</span>
            </button>
            <button
              v-show="estado === 'F'"
              type="button"
              @click="restablecerInicio"
              class="btn-warning btn--text"
            >
              <i class="fa fa-refresh"></i><span>Restablecer inicio</span>
            </button>
            <button
              v-show="estado !== 'N' && estado !== 'A'"
              type="button"
              @click="verRubros"
              class="btn-warning btn--text"
            >
              <i class="fa fa-money"></i><span>Rubros finales</span>
            </button>
            <button
              v-show="estado !== 'N'"
              type="button"
              @click="imprimir"
              class="btn-success btn--text"
            >
              <i class="fa fa-print"></i><span>Imprimir</span>
            </button>
            <button
              v-show="estado !== 'N'"
              type="button"
              @click="imprimirResumen"
              class="btn-secondary btn--text"
            >
              <i class="fa fa-print"></i><span>Imprimir resumen</span>
            </button>
            <button
              v-show="estado === 'P' && puede_eliminar_visita"
              type="button"
              @click="anular"
              class="btn-danger btn--text"
            >
              <i class="fa fa-ban"></i><span>Anular</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <modal
      width="80%"
      height="auto"
      name="listaVisitas"
      scrollable
      adaptive
      reset
      resizable
    >
      <lista-visitas
        :bodegas="bodegas"
        @seleccionar="selectedVisita"
        @cerrar="cerrarListaVisitas"
      ></lista-visitas>
    </modal>
    <modal
      name="rubrosVisita"
      height="auto"
      width="90%"
      scrollable
      adaptive
      reset
      resizable
    >
      <rubros-visita
        :visitaId="id"
        @cerrar="$modal.hide('rubrosVisita')"
      ></rubros-visita>
    </modal>
  </div>
</template>

<script>
import ListaVisitas from "./ListaVisitas.vue";
import ItemsVisitas from "./ItemsVisitas.vue";
import ItemsAdicionales from "./ItemsAdicionales.vue";
import RubrosVisita from "./RubrosVisita.vue";
export default {
  mounted: function () {
    if (this.visitaId != "")
      this.selectedVisita({
        id: this.visitaId,
      });
  },
  props: [
    "visitaId",
    "puede_crear_visita",
    "puede_editar_visita",
    "puede_eliminar_visita",
    "puede_consultar_visitas",
    "bodegas",
  ],
  computed: {
    totalRubros: function () {
      let almuerzo = parseFloat(this.form.almuerzo_inicial);
      if (isNaN(almuerzo)) almuerzo = 0;
      let peaje = parseFloat(this.form.peaje_inicial);
      if (isNaN(peaje)) peaje = 0;
      let gasolina = parseFloat(this.form.combustible_inicial);
      if (isNaN(gasolina)) gasolina = 0;
      let otros = parseFloat(this.form.otros_inicial);
      if (isNaN(otros)) otros = 0;
      return round(almuerzo + peaje + gasolina + otros, 2);
    },
  },
  components: {
    ListaVisitas,
    ItemsVisitas,
    ItemsAdicionales,
    RubrosVisita,
  },
  data: function () {
    return {
      moneyFormat: moneyFormat,
      money: money,
      latLngInicio: null,
      latLngFin: null,
      latLngCancelacion: null,
      vendedoresPertenecientes: [],
      vendedores: [],
      selectedRecaudador: null,
      recaudadores: [],
      supervisores: [],
      selectedSupervisor: null,
      selectedVerificador: null,
      form: {
        almuerzo_inicial: 0,
        peaje_inicial: 0,
        combustible_inicial: 0,
        otros_inicial: 0,
        movimientosAdicionales: [],
        fecha: moment(new Date()).format("YYYY-MM-DD HH:mm"),
        observacion: "",
        supervisor_id: "",
        recaudador_id: "",
        verificador_id: "",
        ruta_id: "",
        _method: undefined,
        items: [],
        referencia_movimiento: "",
        dia_cobro: "",
        vendedores: [],
        fecha_inicio: "",
        fecha_fin: "",
        fecha_cancelacion: "",
        observacion_inicio: "",
        observacion_fin: "",
        observacion_cancelacion: "",
        latitud_inicio: "",
        longitud_inicio: "",
        latitud_fin: "",
        longitud_fin: "",
        latitud_cancelacion: "",
        longitud_cancelacion: "",
        direccion_inicio: "",
        direccion_fin: "",
        direccion_cancelacion: "",
        descripcion_movimiento: "",
      },
      estado: "N",
      errores: {},
      rutas: [],
      selectedRuta: null,
      id: "",
      verificadores: [],
      selectedVendedor: null,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      zoom: 18,
      center: [-2.1408961, -79.9080648],
      clientIcon: L.icon({
        iconUrl: url + "/images/customer.png",
        iconAnchor: [16, 16],
      }),
      markerIcon: L.icon({
        iconUrl: url + "/images/location.png",
        iconAnchor: [16, 16],
      }),
    };
  },
  methods: {
    verRubros: function () {
      this.$modal.show("rubrosVisita");
    },
    imprimirResumen: function () {
      window.open(
        url + "/logistica/visitas/" + this.id + "/imprimir-resumen",
        "_blank"
      );
    },
    restablecerInicio: function () {
      swal({
        title: "¿Deseas restablecer el inicio de la visita?",
        text: "Se pondrá la visita como iniciada",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/logistica/visitas/" + this.id + "/restablecer-inicio")
            .then(() => {
              swal("La visita fue dada como iniciada.", "Realizado", "success");
              this.estado = "I";
            })
            .catch(({ response }) => {
              if (response.status === 404) {
                swal(
                  "La visita no corresponde al día de hoy, no se puede continuar.",
                  "Aviso",
                  "warning"
                );
              } else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    centerUpdated(center) {
      this.center = center;
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    verCoordenadasCancelacion: function () {
      this.center = [
        this.form.latitud_cancelacion,
        this.form.longitud_cancelacion,
      ];
      this.zoom = 18;
      this.$forceUpdate();
    },
    verCoordenadasFin: function () {
      this.center = [this.form.latitud_fin, this.form.longitud_fin];
      this.zoom = 18;
      this.$forceUpdate();
    },
    verCoordenadasInicio: function () {
      this.center = [this.form.latitud_inicio, this.form.longitud_inicio];
      this.zoom = 18;
      this.$forceUpdate();
    },
    verificarPertenencia: function (vendedorId) {
      for (let i = 0; i < this.vendedoresPertenecientes.length; i++) {
        if (this.vendedoresPertenecientes[i].id == vendedorId) {
          return "S";
        }
      }
      return "N";
    },
    eliminarVendedor: function (index) {
      swal({
        title: "¿Deseas quitar al vendedor de la visita?",
        text: "Se quitará al vendedor de la visita",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          this.form.vendedores.splice(index, 1);
        }
      });
    },
    searchVendedores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.vendedores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/vendedores?search=" + search, true);
      xmlhttp.send();
    },
    inputVendedor: function () {
      if (this.selectedVendedor != null) {
        let existe = false;
        for (let i = 0; i < this.form.vendedores.length; i++) {
          if (this.form.vendedores[i].id == this.selectedVendedor.id) {
            existe = true;
            break;
          }
        }
        if (!existe)
          this.form.vendedores.push({
            descripcion: this.selectedVendedor.descripcion,
            direccion: this.selectedVendedor.direccion,
            telefonos: this.selectedVendedor.telefonos,
            correos: this.selectedVendedor.correos,
            id: this.selectedVendedor.id,
            pertenece: this.verificarPertenencia(this.selectedVendedor.id),
          });
        setTimeout(() => {
          this.selectedVendedor = null;
        }, 500);
      }
    },
    imprimir: function () {
      window.open(
        url + "/logistica/visitas/" + this.id + "/imprimir",
        "_blank"
      );
    },
    quitarItems: function () {
      this.form.items.splice(0, this.form.items.length);
    },
    importar: function () {
      axios
        .get(url + "/inventario/movimientos", {
          params: {
            referencia_movimiento: this.form.referencia_movimiento,
            tipo: "V",
            id: this.id,
            ruta_id: this.form.ruta_id
          },
        })
        .then(({ data }) => {
          // if (data.length === 0) {
          //   swal(
          //     "No se ha encontrado el movimiento indicado.",
          //     "Aviso",
          //     "warning"
          //   );
          // } else {
            
          // }

          for (let i = 0; i < data.length; i++) {
              this.form.items.push({
                item_id: data[i].item_id,
                nombre_item: data[i].nombre,
                cantidad: data[i].cantidad,
                codigo_barra: data[i].codigo_barra,
              });
            }
        })
        .catch(({ response }) => {
          const {status, data: { errors }} = response;
          if (status === 409) {
            swal(
              "El movimiento ya ha sido referenciado con anterioridad.",
              "Aviso",
              "warning"
            );
            return;
          }
          if (status === 422) 
            swal(errors.producto[0], "Aviso", "warning");
          else swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    inputRecaudador: function () {
      if (this.selectedRecaudador != null)
        this.form.recaudador_id = this.selectedRecaudador.id;
      else this.form.recaudador_id = "";
    },
    searchRecaudadores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.recaudadores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?tipo=R&search=" + search,
        true
      );
      xmlhttp.send();
    },
    searchSupervisores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.supervisores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?tipo=S&search=" + search,
        true
      );
      xmlhttp.send();
    },
    inputSupervisor: function () {
      if (this.selectedSupervisor != null)
        this.form.supervisor_id = this.selectedSupervisor.id;
      else this.form.supervisor_id = "";
    },
    searchVerificadores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.verificadores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/verificadores?tipo=V&search=" + search,
        true
      );
      xmlhttp.send();
    },
    inputVerificador: function () {
      if (this.selectedVerificador != null)
        this.form.verificador_id = this.selectedVerificador.id;
      else this.form.verificador_id = "";
    },
    anular: function () {
      swal({
        title: "¿Deseas anular la visita?",
        text: "Se reiniciará el formulario",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/logistica/visitas/" + this.id, {
              _method: "DELETE",
            })
            .then(({ data }) => {
              this.estado = data.estado;
              swal(
                "La visita ha sido anulado exitósamente.",
                "Realizado",
                "success"
              );
            });
        }
      });
    },
    selectedVisita: function (row) {
      axios.get(url + "/logistica/visitas/" + row.id).then(({ data }) => {
        let visita = data;
        this.form.almuerzo_inicial = visita.almuerzo_inicial;
        this.form.peaje_inicial = visita.peaje_inicial;
        this.form.combustible_inicial = visita.combustible_inicial;
        this.form.otros_inicial = visita.otros_inicial;
        this.form.direccion_inicio = visita.direccion_inicio;
        this.form.direccion_fin = visita.direccion_fin;
        this.form.direccion_cancelacion = visita.direccion_cancelacion;
        this.form.dia_cobro = visita.dia_cobro;
        this.form.fecha = visita.fecha;
        this.form.descripcion_movimiento = visita.descripcion_movimiento;
        this.form.observacion = visita.observacion;
        this.estado = visita.estado;
        this.selectedVerificador = visita.verificador;
        this.form.verificador_id = visita.verificador_id;
        this.form.supervisor_id = visita.supervisor_id;
        this.form.recaudador_id = visita.recaudador_id;
        this.form.referencia_movimiento = visita.referencia_movimiento;
        this.form.fecha_inicio = visita.fecha_inicio;
        this.form.observacion_inicio = visita.observacion_inicio;
        this.form.fecha_fin = visita.fecha_fin;
        this.form.observacion_fin = visita.observacion_fin;
        this.form.fecha_cancelacion = visita.fecha_cancelacion;
        this.form.observacion_cancelacion = visita.observacion_cancelacion;
        if (visita.coordenadas_inicio != null) {
          this.form.latitud_inicio = visita.coordenadas_inicio.coordinates[1];
          this.form.longitud_inicio = visita.coordenadas_inicio.coordinates[0];
          this.latLngInicio = [
            visita.coordenadas_inicio.coordinates[1],
            visita.coordenadas_inicio.coordinates[0],
          ];
        } else {
          this.form.latitud_inicio = "";
          this.form.longitud_inicio = "";
          this.latLngInicio = null;
        }
        if (visita.coordenadas_fin != null) {
          this.form.latitud_fin = visita.coordenadas_fin.coordinates[1];
          this.form.longitud_fin = visita.coordenadas_fin.coordinates[0];
          this.latLngFin = [
            visita.coordenadas_fin.coordinates[1],
            visita.coordenadas_fin.coordinates[0],
          ];
        } else {
          this.form.latitud_fin = "";
          this.form.longitud_fin = "";
          this.latLngFin = null;
        }
        if (visita.coordenadas_cancelacion != null) {
          this.form.latitud_cancelacion =
            visita.coordenadas_cancelacion.coordinates[1];
          this.form.longitud_cancelacion =
            visita.coordenadas_cancelacion.coordinates[0];
          this.latLngCancelacion = [
            visita.coordenadas_cancelacion.coordinates[1],
            visita.coordenadas_cancelacion.coordinates[0],
          ];
        } else {
          this.form.latitud_cancelacion = "";
          this.form.longitud_cancelacion = "";
          this.latLngCancelacion = null;
        }
        this.selectedSupervisor = {
          id: visita.supervisor.id,
          nombre: visita.supervisor.nombre,
        };
        this.selectedRecaudador = {
          id: visita.recaudador.id,
          nombre: visita.recaudador.nombre,
        };
        this.id = visita.id;
        this.selectedRuta = {
          id: visita.ruta_id,
          descripcion: visita.ruta.descripcion,
        };
        this.form.ruta_id = visita.ruta_id;
        this.form.items.splice(0, this.form.items.length);
        for (let i = 0; i < visita.items.length; i++) {
          this.form.items.push({
            item_id: visita.items[i].item_id,
            nombre_item: visita.items[i].item.nombre,
            cantidad: visita.items[i].cantidad,
            codigo_barra: visita.items[i].codigo_barra,
          });
        }
        this.form.vendedores.splice(0, this.form.vendedores.length);
        for (let i = 0; i < visita.vendedores.length; i++) {
          this.form.vendedores.push({
            descripcion: visita.vendedores[i].descripcion,
            direccion: visita.vendedores[i].direccion,
            telefonos: visita.vendedores[i].telefonos,
            correos: visita.vendedores[i].correos,
            id: visita.vendedores[i].id,
            pertenece: visita.vendedores[i].pivot.pertenece,
          });
        }
        this.form.movimientosAdicionales.splice(
          0,
          this.form.movimientosAdicionales.length
        );
        for (let i = 0; i < visita.movimientos_adicionales.length; i++)
          this.form.movimientosAdicionales.push({
            id: visita.movimientos_adicionales[i].id,
            created_at: visita.movimientos_adicionales[i].created_at,
            cantidad_items: visita.movimientos_adicionales[i].cantidad_items,
            referencia_movimiento:
              visita.movimientos_adicionales[i].referencia_movimiento,
          });
        this.vendedoresPertenecientes = visita.ruta.vendedores;
        this.$modal.hide("listaVisitas");
      });
    },
    cerrarListaVisitas: function () {
      this.$modal.hide("listaVisitas");
    },
    nueva: function () {
      swal({
        title: "¿Deseas crear una nueva visita?",
        text: "Se reiniciará el formulario",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          this.errores = {};
          this.id = "";
          this.form.direccion_inicio = "";
          this.form.direccion_fin = "";
          this.form.direccion_cancelacion = "";
          this.form.fecha = moment(new Date()).format("YYYY-MM-DD HH:mm");
          this.form.observacion = "";
          (this.form.descripcion_movimiento = ""), (this.form.ruta_id = "");
          this.selectedRuta = null;
          this.form.recaudador_id = "";
          this.form.supervisor_id = "";
          this.form.verificador_id = "";
          this.selectedVerificador = null;
          this.selectedSupervisor = null;
          this.selectedRecaudador = null;
          this.form.referencia_movimiento = "";
          this.form.fecha_inicio = "";
          this.form.fecha_fin = "";
          this.form.fecha_cancelacion = "";
          this.form.observacion_inicio = "";
          this.form.observacion_fin = "";
          this.form.observacion_cancelacion = "";
          this.form.latitud_inicio = "";
          this.form.longitud_inicio = "";
          this.latLngInicio = null;
          this.latLngFin = null;
          this.latLngCancelacion = null;
          this.form.latitud_fin = "";
          this.form.longitud_fin = "";
          this.form.latitud_cancelacion = "";
          this.form.longitud_cancelacion = "";
          this.form.items.splice(0, this.form.items.length);
          this.form.dia_cobro = "";
          this.estado = "N";
          this.form.movimientosAdicionales.splice(
            0,
            this.form.movimientosAdicionales.length
          );
          this.form.vendedores.splice(0, this.form.vendedores.length);
        }
      });
    },
    guardar: function () {
      for (let i = 0; i < this.form.items.length; i++) {
        if (this.form.items[i].item_id == "") {
          swal(
            "El item es requerido en la fila: " + (i + 1),
            "Aviso",
            "warning"
          );
          return;
        } else if (
          this.form.items[i].cantidad == "" ||
          this.form.items[i].cantidad == null ||
          parseFloat(this.form.items[i].cantidad) == 0
        ) {
          swal(
            "La cantidad es requerida y debe ser mayor a cero en la fila: " +
              (i + 1),
            "Aviso",
            "warning"
          );
          return;
        }
      }
      this.errores = {};
      swal({
        title: "¿Deseas guardar la vista?",
        text: "Se almacenará la información de la visita",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          let urlRequest = url + "/logistica/visitas";
          if (this.estado !== "N") {
            urlRequest += "/" + this.id;
            this.form._method = "PUT";
          } else this.form._method = undefined;
          axios
            .post(urlRequest, this.form)
            .then(({ data }) => {
              swal(
                "La visita ha sido almacenada exitósamente.",
                "Aviso",
                "success"
              );
              this.id = data.id;
              this.estado = data.estado;
            })
            .catch(({ response }) => {
              let status = response.status;
              if (status == 422) {
                this.errores = response.data.errors;
                swal("Hay errores en el formulario.", "Aviso", "warning");
              } else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    onSearchRutas: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.rutas = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/rutas?search=" + search + "&fecha=" + this.form.fecha,
        true
      );
      xmlhttp.send();
    },
    consultar: function () {
      this.$modal.show("listaVisitas");
    },
    cargarRuta: function () {
      if (this.selectedRuta != null)
        axios
          .get(url + "/logistica/rutas/" + this.selectedRuta.id)
          .then(({ data }) => {
            this.form.vendedores = data.vendedores;
            this.vendedoresPertenecientes = data.vendedores;
          });
      else this.form.vendedores.splice(0, this.form.vendedores.length);
    },
    inputRuta: function () {
      if (this.selectedRuta != null) {
        this.form.ruta_id = this.selectedRuta.id;
        this.selectedRecaudador = {
          id: this.selectedRuta.recaudador.id,
          nombre: this.selectedRuta.recaudador.nombre,
        };
        this.form.recaudador_id = this.selectedRuta.recaudador.id;
      } else {
        this.form.ruta_id = "";
      }
      this.cargarRuta();
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/visitas/Visita.vue